var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center gap-2 p-2 border rounded",attrs:{"role":"button"},on:{"click":function($event){return _vm.copyApiKey()}}},[_c('span',{staticClass:"api-key"},[_vm._v(_vm._s(_vm.rowData.apiKey.slice(0, 20))+"...")]),_c('i',{staticClass:"fa fa-clipboard",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }